import { RichTextModule } from "components/RichTextModule";
import React from "react";

import { ContentModuleBaseAttributes } from "utils/orm";

import styles from "./divider.module.scss";

export interface DividerBlock extends ContentModuleBaseAttributes {
    richText?: string;
}

export const DividerModule: React.FC<DividerBlock> = ({ heading, richText }) => (
    <section className={styles.divider}>
        {heading && <h2>{heading}</h2>}
        {richText && <RichTextModule {...{ richText, type: "richTextBlock" }} />}
    </section>
);
